export type PixelString = string & { __validPixelString: true };

export default function isValidPixelString(pixelString: string): pixelString is PixelString {
  const regex = new RegExp(/^[0-9]+px$/);
  return regex.test(pixelString);
}
